import { render, staticRenderFns } from "./SidebarItemList.vue?vue&type=template&id=1cb9c946&scoped=true&"
import script from "./SidebarItemList.vue?vue&type=script&lang=js&"
export * from "./SidebarItemList.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemList.vue?vue&type=style&index=0&id=1cb9c946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9c946",
  null
  
)

export default component.exports